window.TabOverflow = {
    init() {
        this.handleOverflow();
    },

    handleOverflow() {
        const tabBar = document.querySelector('[data-overflow="tabbar"]');
        const moreItem = document.querySelector('[data-overflow="more-item"]');
        const moreMenu = document.querySelector('[data-overflow="more-menu"]');
        if (tabBar && moreItem && moreMenu) {
            const debouncedLayout = debounce(layout, 50);

            window.addEventListener('resize', debouncedLayout);
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(debouncedLayout);
            }

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(layout));
            } else {
                requestAnimationFrame(layout);
            }

            window.addEventListener('load', () => requestAnimationFrame(layout));

            if (window.Turbolinks) {
                document.addEventListener('turbolinks:load', () => requestAnimationFrame(layout));
            }

            const resizeObserver = new ResizeObserver(() => debouncedLayout());
            resizeObserver.observe(tabBar);
        }
    }
}

function debounce(fn, ms) {
    let t;
    return function debounced() {
        clearTimeout(t);
        t = setTimeout(fn, ms);
    };
}

function tabToDropdown(li) {
    const link = li.querySelector('a.nav-link, a');
    if (!link) return null;

    const a = document.createElement('a');
    a.className = 'dropdown-item';
    a.href = link.getAttribute('href') || '#';
    a.textContent = (link.textContent || '').trim();
    if (link.target) a.target = link.target;
    if (link.classList.contains('active')) a.classList.add('active');
    a.addEventListener('click', (e) => {
        if (link.hasAttribute('data-toggle')) {
            e.preventDefault();
            link.click();
        }
    });
    a.dataset.sourceId = li.id || '';
    return a;
}

function dropdowntoTab(a) {
    const li = document.createElement('li');
    li.className = 'nav-item';
    if (a.dataset.sourceId) li.id = a.dataset.sourceId;

    const link = document.createElement('a');
    link.className = 'nav-link';
    link.href = a.getAttribute('href') || '#';
    link.textContent = (a.textContent || '').trim();
    if (a.target) link.target = a.target;
    if (a.classList.contains('active')) link.classList.add('active');

    li.appendChild(link);
    return li;
}

function visibleTabs() {
    const tabBar = document.querySelector('[data-overflow="tabbar"]');
    return Array.from(tabBar.children).filter((li) => !isMoreItem(li));
}

function isMoreItem(el) {
    const moreItem = document.querySelector('[data-overflow="more-item"]');
    return el === moreItem;
}

function layout() {
    const tabBar = document.querySelector('[data-overflow="tabbar"]');
    const moreItem = document.querySelector('[data-overflow="more-item"]');
    const moreMenu = document.querySelector('[data-overflow="more-menu"]');

    Array.from(moreMenu.children).forEach((a) => {
        const li = dropdowntoTab(a);
        tabBar.insertBefore(li, moreItem);
        a.remove();
    });

    moreItem.classList.add('d-none');
    if (tabBar.scrollWidth <= tabBar.clientWidth) return;

    moreItem.classList.remove('d-none');

    let guard = 200;
    while (guard-- > 0 && tabBar.scrollWidth > tabBar.clientWidth) {
        const items = visibleTabs();
        if (items.length === 0) break;

        const last = items[items.length - 1];
        const dropdownItem = tabToDropdown(last);
        if (!dropdownItem) break;

        moreMenu.insertBefore(dropdownItem, moreMenu.firstChild);
        last.remove();
    }

    if (moreMenu.children.length === 0) {
        moreItem.classList.add('d-none');
    }
}
